import React, { useContext, useState, useEffect } from 'react'
import Tabs from './Tabs'
import LoadingSpinner from './LoadingSpinner'
import './ProjectDetail/ProjectDetail.css'

export default function ProductDetail(props) {
  const [product, setProduct] = useState(props.product)
  const [loading,setLoading] = useState(true)

  useEffect(() => {
    setProduct(props.product)
    setLoading(false)
  }, [])

  if(loading){
    return <LoadingSpinner />
  }
  console.log("Product Detail",props.product)

  return (
    <form className="detailCard-project">
      <div className="detailProjectHeader">
        <h3 className="bolder">{product.certification_job_number}</h3>
        <p>-</p>
        <h3 className="bolder">{product.certification_job_name}</h3>
      </div>
      <Tabs>
        <div label="Project Details">
          <table className="project-detail-table">
            <tbody>
              <tr>
                <td>Certification Category</td>
                <td >{product.product_category}</td>
              </tr>
              <tr>
                <td>Certification Job Name</td>
                <td >{product.certification_job_name}</td>
              </tr>
              <tr>
                <td>Manufacturer</td>
                <td >{product.crm_account_name}</td>
              </tr>
              <tr>
                <td>Certification Job Date</td>
                <td >{new Date(product.certification_job_date).toLocaleDateString()}</td>
              </tr>
              <tr>
                <td>Certification Job Expiration Date</td>
                <td >{new Date(product.certification_job_expiration_date).toLocaleDateString()}</td>
              </tr>
              <tr>
                <td>Certifcation Job Number</td>
                <td >{product.certification_job_number}</td>
              </tr>
              <tr>
                <td>Job Folder</td>
                <td >{product.job_folder}</td>
              </tr>
              <tr>
                <td>Submitter</td>
                <td >{product.crm_contact_name}</td>
              </tr>
              <tr>
                <td>Job Status</td>
                <td >{product.job_status}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div label="null">
          <table className="project-detail-table">
          </table>
        </div>
      </Tabs>
    </form>)
}
